import { render, staticRenderFns } from "./ResellerItem.vue?vue&type=template&id=1f406504"
import script from "./ResellerItem.vue?vue&type=script&lang=js"
export * from "./ResellerItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports